var _defs, _g, _path, _circle, _g2, _g3, _g4, _g5, _g6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _path10, _circle3, _circle4, _path11, _path12, _path13, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 791.3 791.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-10,.cls-12,.cls-14,.cls-16,.cls-2,.cls-4,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{mask:url(#mask-5);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{mask:url(#mask-6);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{mask:url(#mask-7);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{mask:url(#mask-8);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{mask:url(#mask-9);}.cls-18{fill:#ff7010;}.cls-19{fill:#031d2e;}.cls-20{mask:url(#mask-10);}.cls-21{mask:url(#mask-11);}.cls-22{mask:url(#mask-12);}.cls-23{mask:url(#mask-13);}.cls-24{mask:url(#mask-14);}.cls-25{mask:url(#mask-15);}.cls-26{mask:url(#mask-16);}.cls-27{filter:url(#luminosity-noclip-16);}.cls-28{filter:url(#luminosity-noclip-15);}.cls-29{filter:url(#luminosity-noclip-14);}.cls-30{filter:url(#luminosity-noclip-13);}.cls-31{filter:url(#luminosity-noclip-12);}.cls-32{filter:url(#luminosity-noclip-11);}.cls-33{filter:url(#luminosity-noclip-10);}.cls-34{filter:url(#luminosity-noclip-9);}.cls-35{filter:url(#luminosity-noclip-8);}.cls-36{filter:url(#luminosity-noclip-7);}.cls-37{filter:url(#luminosity-noclip-6);}.cls-38{filter:url(#luminosity-noclip-5);}.cls-39{filter:url(#luminosity-noclip-4);}.cls-40{filter:url(#luminosity-noclip-3);}.cls-41{filter:url(#luminosity-noclip-2);}.cls-42{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 47.58,
    y: -8553.35,
    width: 694.15,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 47.58,
    y: -8553.35,
    width: 694.15,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 209.66,
    y1: 2414.48,
    x2: 641.77,
    y2: 2165,
    gradientTransform: "translate(1861.16 -1715.54) rotate(45) scale(1.07 1.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 356.32,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 356.32,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5001.29,
    y1: 2832.38,
    x2: 5080.69,
    y2: 2832.38,
    gradientTransform: "translate(3969.39 5266.01) rotate(-157.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 680.1,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 680.1,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 719.8,
    y1: 353.91,
    x2: 719.8,
    y2: 433.31,
    gradientTransform: "translate(937.51 -397.36) rotate(76.72)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 29.8,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 29.8,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3516.48,
    y1: -870.46,
    x2: 3595.88,
    y2: -870.46,
    gradientTransform: "translate(-1829.58 3526.46) rotate(-45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 36.41,
    y: -8553.35,
    width: 716.48,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 36.41,
    y: -8553.35,
    width: 716.48,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3469.33,
    y1: -808.76,
    x2: 4185.8,
    y2: -808.76,
    gradientTransform: "translate(1203.41 4222.55) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 67.51,
    y: -8553.35,
    width: 654.28,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 67.51,
    y: -8553.35,
    width: 654.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1271.25,
    y1: 3827.9,
    x2: 1925.53,
    y2: 3827.9,
    gradientTransform: "translate(4222.55 -1203.41) rotate(90)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 96.36,
    y: -8553.35,
    width: 596.59,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 96.36,
    y: -8553.35,
    width: 596.59,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1563.6,
    y1: -917.8,
    x2: 2160.19,
    y2: -917.8,
    gradientTransform: "translate(-272.92 2360.51) rotate(-45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 353.58,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 353.58,
    y: -8553.35,
    width: 79.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 353.58,
    y1: 69.84,
    x2: 432.98,
    y2: 69.84,
    gradientTransform: "translate(164.57 -257.64) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 47.58,
    y: 47.91,
    width: 694.15,
    height: 694.15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 48.58,
    y: 48.58,
    width: 694.15,
    height: 694.15,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.33,742.06c-26.12,0-46.88-7.15-61.24-21.51-32.1-32.09-28.17-96.17,11-180.43,39-83.8,108.29-177.75,195.09-264.55S456,119.48,539.79,80.47c84.26-39.22,148.33-43.14,180.43-11s28.16,96.17-11.06,180.43c-39,83.8-108.29,177.75-195.09,264.55S333.32,670.49,249.52,709.5C203,731.16,162.57,742.06,130.33,742.06ZM659,50.91c-90.2,0-241.85,87-381.6,226.78C99,456,6.53,653.75,71.21,718.43c14,14,34.22,20.63,59.13,20.63,90.21,0,241.85-87,381.61-226.78C690.3,333.93,782.77,136.22,718.1,71.54,704.1,57.55,683.87,50.91,659,50.91Z"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 36.41,
    y: 36.75,
    width: 716.48,
    height: 716.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 37.41,
    y: 37.41,
    width: 716.48,
    height: 716.48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.65,753.22A358.33,358.33,0,0,1,255.21,64.9,358.33,358.33,0,0,1,534.09,725.07,356,356,0,0,1,394.65,753.22Zm0-713.47A355.24,355.24,0,0,0,143.46,646.18,355.24,355.24,0,1,0,645.84,143.79,352.91,352.91,0,0,0,394.65,39.75Z"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 67.51,
    y: 67.84,
    width: 654.28,
    height: 654.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 68.51,
    y: 68.51,
    width: 654.28,
    height: 654.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.65,722.13A327.14,327.14,0,0,1,163.33,163.66,327.14,327.14,0,0,1,626,626.31,325,325,0,0,1,394.65,722.13Zm0-651.29a324.14,324.14,0,0,0-229.2,553.35,324.14,324.14,0,0,0,458.4-458.41A322,322,0,0,0,394.65,70.84Z"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 96.36,
    y: 96.69,
    width: 596.59,
    height: 596.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 97.36,
    y: 97.36,
    width: 596.59,
    height: 596.59,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M394.65,693.28a298.28,298.28,0,1,1,210.93-87.37A296.33,296.33,0,0,1,394.65,693.28Zm0-593.59a295.28,295.28,0,1,0,208.81,86.49A293.37,293.37,0,0,0,394.65,99.69Z"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 353.58,
    y: 30.14,
    width: 79.4,
    height: 79.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 354.58,
    y: 30.8,
    width: 79.4,
    height: 79.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 393.28,
    cy: 69.84,
    r: 39.7,
    transform: "translate(65.81 298.55) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 356.32,
    y: 680.43,
    width: 79.4,
    height: 79.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 357.32,
    y: 681.1,
    width: 79.4,
    height: 79.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 396.02,
    cy: 720.13,
    r: 39.7,
    transform: "translate(-245.44 206.37) rotate(-22.5)"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 680.1,
    y: 353.91,
    width: 79.4,
    height: 79.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 681.1,
    y: 354.58,
    width: 79.4,
    height: 79.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 719.8,
    cy: 393.61,
    r: 39.7,
    transform: "translate(171.34 1003.72) rotate(-76.72)"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 29.8,
    y: 356.65,
    width: 79.4,
    height: 79.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 30.8,
    y: 357.32,
    width: 79.4,
    height: 79.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 69.5,
    cy: 396.36,
    r: 39.7,
    transform: "translate(-259.91 165.24) rotate(-45)"
  }))))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector Smart Object") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M130.33,742.06c-26.12,0-46.88-7.15-61.24-21.51-32.1-32.09-28.17-96.17,11-180.43,39-83.8,108.29-177.75,195.09-264.55S456,119.48,539.79,80.47c84.26-39.22,148.33-43.14,180.43-11s28.16,96.17-11.06,180.43c-39,83.8-108.29,177.75-195.09,264.55S333.32,670.49,249.52,709.5C203,731.16,162.57,742.06,130.33,742.06ZM659,50.91c-90.2,0-241.85,87-381.6,226.78C99,456,6.53,653.75,71.21,718.43c14,14,34.22,20.63,59.13,20.63,90.21,0,241.85-87,381.61-226.78C690.3,333.93,782.77,136.22,718.1,71.54,704.1,57.55,683.87,50.91,659,50.91Z",
    transform: "translate(1 0.67)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M-.56,790.2h0a1.49,1.49,0,0,1,0-2.12L787.74-.23a1.51,1.51,0,0,1,2.12,0h0a1.49,1.49,0,0,1,0,2.12L1.56,790.2A1.51,1.51,0,0,1-.56,790.2Z",
    transform: "translate(1 0.67)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 395.65,
    cy: 395.65,
    r: 237.04
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M394.65,753.22A358.33,358.33,0,0,1,255.21,64.9,358.33,358.33,0,0,1,534.09,725.07,356,356,0,0,1,394.65,753.22Zm0-713.47A355.24,355.24,0,0,0,143.46,646.18,355.24,355.24,0,1,0,645.84,143.79,352.91,352.91,0,0,0,394.65,39.75Z",
    transform: "translate(1 0.67)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M394.65,722.13A327.14,327.14,0,0,1,163.33,163.66,327.14,327.14,0,0,1,626,626.31,325,325,0,0,1,394.65,722.13Zm0-651.29a324.14,324.14,0,0,0-229.2,553.35,324.14,324.14,0,0,0,458.4-458.41A322,322,0,0,0,394.65,70.84Z",
    transform: "translate(1 0.67)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M394.65,693.28a298.28,298.28,0,1,1,210.93-87.37A296.33,296.33,0,0,1,394.65,693.28Zm0-593.59a295.28,295.28,0,1,0,208.81,86.49A293.37,293.37,0,0,0,394.65,99.69Z",
    transform: "translate(1 0.67)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 393.28,
    cy: 69.84,
    r: 39.7,
    transform: "translate(66.81 299.21) rotate(-45)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 396.02,
    cy: 720.13,
    r: 39.7,
    transform: "translate(-244.44 207.03) rotate(-22.5)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M639.77,164.11A16.18,16.18,0,1,1,635,152.67,16,16,0,0,1,639.77,164.11Z",
    transform: "translate(1 0.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M637.55,150.15a19.77,19.77,0,1,0,5.76,14A19.66,19.66,0,0,0,637.55,150.15Zm-25.39,25.39a16.19,16.19,0,1,1,11.43,4.73A16,16,0,0,1,612.16,175.54Z",
    transform: "translate(1 0.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M623.59,640.1A16.18,16.18,0,1,1,635,635.36,16,16,0,0,1,623.59,640.1Z",
    transform: "translate(1 0.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M637.55,637.88a19.76,19.76,0,1,0-14,5.77A19.64,19.64,0,0,0,637.55,637.88ZM612.16,612.5a16.15,16.15,0,1,1-4.74,11.42A16,16,0,0,1,612.16,612.5Z",
    transform: "translate(1 0.67)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M163.77,147.93a16.17,16.17,0,1,1-11.44,4.74A16,16,0,0,1,163.77,147.93Z",
    transform: "translate(1 0.67)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M149.82,150.15a19.75,19.75,0,1,0,14-5.77A19.6,19.6,0,0,0,149.82,150.15Zm25.38,25.39a16.16,16.16,0,1,1,4.74-11.43A16,16,0,0,1,175.2,175.54Z",
    transform: "translate(1 0.67)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M147.6,627.47a16.17,16.17,0,1,1,4.73,11.44A16,16,0,0,1,147.6,627.47Z",
    transform: "translate(1 0.67)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M149.82,641.43a19.76,19.76,0,1,0-5.77-14A19.61,19.61,0,0,0,149.82,641.43ZM175.2,616a16.16,16.16,0,1,1-11.43-4.74A16,16,0,0,1,175.2,616Z",
    transform: "translate(1 0.67)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 677.87,
    cy: 113.43,
    r: 31.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M676.87,145.76a33,33,0,0,1-23.33-56.33h0a33,33,0,1,1,23.33,56.33Zm0-63a29.83,29.83,0,0,0-21.21,8.78h0a30,30,0,1,0,21.21-8.78Z",
    transform: "translate(1 0.67)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 677.87,
    cy: 113.43,
    r: 18.78
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 110.21,
    cy: 681.1,
    r: 31.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.21,713.41a33,33,0,1,1,23.33-9.65A32.89,32.89,0,0,1,109.21,713.41Zm0-63a30,30,0,1,0,21.21,8.77A29.9,29.9,0,0,0,109.21,650.45Z",
    transform: "translate(1 0.67)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M122.49,693.72A18.77,18.77,0,0,1,91.59,687a18.79,18.79,0,0,0,24.13-24.13,18.77,18.77,0,0,1,6.77,30.9Z",
    transform: "translate(1 0.67)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M394.65,633.52a238.53,238.53,0,1,1,168.67-69.86A237,237,0,0,1,394.65,633.52ZM227,227.37l1.06,1.06a235.55,235.55,0,1,0,166.55-69,234,234,0,0,0-166.55,69Z",
    transform: "translate(1 0.67)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 719.8,
    cy: 393.61,
    r: 39.7,
    transform: "translate(172.34 1004.39) rotate(-76.72)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 69.5,
    cy: 396.36,
    r: 39.7,
    transform: "translate(-258.91 165.9) rotate(-45)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.33ca4de8d4edf86439ed6b7b493adedf.svg";
export { ForwardRef as ReactComponent };